import axiosInstance from "./api";

export const fetchBannerAds = async (page = 1, limit = 10) => {
  try {
    const response = await axiosInstance.get(
      `/bannerAd?page=${page}&limit=${limit}`
    );
    if (response?.data?.success) {
      return response.data.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error fetching banner ads:", error);
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const fetchBannerAdById = async (id) => {
  try {
    const response = await axiosInstance.get(`/bannerAd/${id}`);
    if (response?.data?.success) {
      return response.data.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error fetching banner ad:", error);
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const createBannerAd = async (formData) => {
  try {
    // Convert isActive to boolean
    const isActiveValue = formData.get("isActive");
    const isActiveBool = isActiveValue === "true" || isActiveValue === true;
    formData.set("isActive", isActiveBool);
    
    const response = await axiosInstance.post("/bannerAd", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response?.data?.success) {
      return response.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error creating banner ad:", error);
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const updateBannerAd = async (id, formData) => {
  try {
    const response = await axiosInstance.patch(`/bannerAd/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response?.data?.success) {
      return response.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error updating banner ad:", error);
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

export const deleteBannerAd = async (id) => {
  try {
    const response = await axiosInstance.delete(`/bannerAd/${id}`);
    if (response?.data?.success) {
      return response.data;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error deleting banner ad:", error);
    throw new Error(error.response?.data?.message || "Something went wrong");
  }
};

